import React from "react";
import moment from "moment";
import "./actions.css";
import Error from "../error/error"

const actions = props => {
  let cardContent = <p>There are no actions to display.</p>;
  if (props.actions.error) cardContent = Error(props.actions.error);

  if (props.actions.actions.length > 0) {
    cardContent = props.actions.actions.map(action => {
      let actionColor = "secondary";
      let actionButtonText = "";
      let actionDate = "";
      let actionOutline = null;
      let actionDisabled = null;

      switch (action.status) {
        case 0: // Not completed
          actionColor = "danger";
          actionButtonText = "Action";
          actionDate = moment(action.availableDate).format("DD/MM/YYYY");
          break;
        case 1: // In Progress
          actionColor = "warning";
          actionButtonText = "In Progress";
          actionDate = moment(action.completedDate).format("DD/MM/YYYY");
          break;
        case 2: // Completed
          actionColor = "success";
          actionButtonText = "Completed";
          actionDate = moment(action.completedDate).format("DD/MM/YYYY");
          actionOutline = "success";
          actionDisabled = "disabled";
          break;
        default:
          break;
      }
      return (
        <mosaic-alert key={action.actionId} color={actionColor}>
          <mosaic-alert-text>
            <p>
              <strong>{action.actionDescription}</strong>
              <br />
              {actionDate}
            </p>
          </mosaic-alert-text>
          <mosaic-alert-actions>
            <mosaic-button
              button-class="fixed-width"
              color={actionColor}
              outline={actionOutline}
              disabled={actionDisabled}
              onClick={() =>
                props.onClick(
                  action.actionId,
                  action.actionDescription,
                  action.projectId,
                  action.screenId
                )
              }
            >
              {actionButtonText}
            </mosaic-button>
          </mosaic-alert-actions>
        </mosaic-alert>
      );
    });
  }

  return (
    <mosaic-col xl="6">
      <mosaic-card id={props.cardName} fixed-height full-height>
        <mosaic-card-header
          title="Actions"
          badge={
            props.notCompletedActionCount === 0
              ? null
              : props.notCompletedActionCount
          }
          badgecolor={props.notCompletedActionCount === 0 ? "" : "danger"}
          pill
        />

        <mosaic-card-body>
          <div>{cardContent}</div>
        </mosaic-card-body>
      </mosaic-card>
    </mosaic-col>
  );
};

export default actions;
